import React from 'react';
import {useViewport} from './Viewport';
import {useOverlay} from './OverlayContext';

type SpringPopoverContext = boolean;
const SpringPopoverContext = React.createContext<SpringPopoverContext>(false);

export const RegisterPopoverWithOverlay = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isNested = React.useContext(SpringPopoverContext);
  if (isNested) {
    return children;
  } else {
    return (
      <SpringPopoverContext.Provider value>
        {children}
      </SpringPopoverContext.Provider>
    );
  }
};

export const useIsWithinSpringPopover = () => {
  return React.useContext(SpringPopoverContext);
};

export const useSpringPopoverViewport = () => {
  const inheritedViewport = useViewport();
  const overlayContext = useOverlay();
  const overlayViewport = overlayContext?.[0]?.box;
  const isWithinSpringPopover = React.useContext(SpringPopoverContext);

  const viewport =
    isWithinSpringPopover && overlayViewport
      ? overlayViewport
      : inheritedViewport;

  return React.useMemo(() => viewport, [viewport]);
};
